var swiper = new Swiper(".pil-slider.swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

var swiper = new Swiper(".testi-slider.swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// var swiper = new Swiper(".cstm-zoom-img-new.swiper", {
//     slidesPerView: 1,
//     spaceBetween: 0,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });

var swiper = new Swiper(".pil-blk-cov-mob.swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// First scroll event handler
window.addEventListener("scroll", () => {
    const elements = document.querySelectorAll(".pil-blk-cov [touching]");
    elements.forEach(element => {
        const className = element.getAttribute("touching");
        const offset = element.getBoundingClientRect().top;
        if (offset <= 200) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    });
});
// Trigger scroll event immediately
window.dispatchEvent(new Event("scroll"));

// Second scroll event handler (document.ready equivalent)
document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener("scroll", () => {
        // Get position of .pil-blk-cov
        const pilBlkCov = document.querySelector(".pil-blk-cov");
        const pdpTopPilBlkCov = pilBlkCov ? pilBlkCov.getBoundingClientRect().top + window.scrollY : NaN;

        // Get position of .pil-block.blocktop-3
        const pilBlock = document.querySelector(".pil-block.blocktop-3");
        const pdpTopPilBlock = pilBlock ? pilBlock.getBoundingClientRect().top + window.scrollY : NaN;

        const scrollPosition = window.scrollY;

        if (!isNaN(pdpTopPilBlkCov) && scrollPosition < pdpTopPilBlkCov) {
            pilBlkCov.classList.add("fixed");
        }

        if (!isNaN(pdpTopPilBlock)) {
            if (scrollPosition < pdpTopPilBlock) {
                pilBlkCov.classList.add("fixed");
            } else {
                pilBlkCov.classList.remove("fixed");
            }
        }
    });
});

/* Accordion JS */

var gridItems = document.querySelectorAll('.grid__item');

gridItems.forEach(function (gridItem) {
    var accordions = gridItem.querySelectorAll('.accordion');

    // Ensure at least 4 accordions exist before adding the "View More" button
    if (accordions.length > 3) {
        var div = document.createElement('div');
        var anchor = document.createElement('a');
        div.classList.add('show-container');
        anchor.href = "javascript:;";
        anchor.classList.add('showMore');
        anchor.textContent = "View more"; // Adding text inside the button
        div.appendChild(anchor);
        gridItem.appendChild(div);

        // Initially show only the first 3 items
        accordions.forEach(function (accordion, index) {
            if (index < 3) {
                accordion.classList.add('shown');
            } else {
                accordion.style.display = 'none';
            }
        });

        // Add click event to toggle visibility
        anchor.addEventListener('click', function () {
            var isExpanded = this.classList.contains('showLess');

            accordions.forEach(function (accordion, index) {
                if (index >= 3) {
                    accordion.style.display = isExpanded ? 'none' : 'block';
                }
            });

            // Toggle class and update text
            this.classList.toggle('showLess');
            this.textContent = isExpanded ? "View more" : "Show less";
        });
    }
});

/* Review Link JS */

const carouselArrows = document.querySelector(".jdgm-carousel .jdgm-carousel__arrows");
    
if (carouselArrows) {
    const viewAllBtn = document.createElement("a");
    viewAllBtn.href = "https://mvmisleep.com/pages/reviews";
    viewAllBtn.className = "reviewall_btn";
    viewAllBtn.textContent = "View all";
    
    carouselArrows.appendChild(viewAllBtn);
}

// Blog url open new tab 
document.addEventListener("DOMContentLoaded", function() {
    // Select all <a> tags inside the blog content
    document.querySelectorAll('.article-content a').forEach(function(link) {
      const href = link.getAttribute('href');
      // Add target="_blank" only if href exists and is not a hash or anchor link
      if (href && !href.startsWith('#') && !href.startsWith('javascript:')) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer'); // Optional, for security
      }
    });
  });
  
//   Add link on reviews 
document.addEventListener('DOMContentLoaded', function () {
    const badge = document.querySelector('.main-product .product .jdgm-widget .jdgm-prev-badge');

    if (badge && !badge.closest('a')) {
        const link = document.createElement('a');
        link.href = '/pages/reviews';

        badge.parentNode.insertBefore(link, badge);
        link.appendChild(badge);
    }

});

/* --- Asset Protection Logic --- */
// document.addEventListener('DOMContentLoaded', function() {
//     // Right-click block
//     document.addEventListener('contextmenu', function(e) {
//         if (e.target.closest && e.target.closest('img, video, iframe, deferred-media')) {
//             e.preventDefault();
//         }
//     }, true);

//     // Drag block (image)
//     document.addEventListener('dragstart', function(e) {
//         if (e.target.closest && e.target.closest('img')) {
//             e.preventDefault();
//         }
//     });
// });